/* CLEO — script.js
   Intersection Observer reveal · Hero letter stagger · Stats counter · FAQ accordion · Form */

(function() {
  'use strict';

  /* -------- HERO TITLE — letter stagger -------- */
  function buildHeroTitle() {
    var el = document.getElementById('heroTitle');
    if (!el) return;
    var words = ['¿Qué', 'es', 'CLEO?'];
    var html = '';
    var idx = 0;
    for (var w = 0; w < words.length; w++) {
      html += '<span class="word">';
      for (var i = 0; i < words[w].length; i++) {
        html += '<span class="letter" style="animation-delay:' + (idx * 0.045) + 's">' + words[w].charAt(i) + '</span>';
        idx++;
      }
      html += '</span>';
      if (w < words.length - 1) html += '<span class="space"> </span>';
    }
    el.innerHTML = html;
    requestAnimationFrame(function() {
      setTimeout(function() { el.classList.add('is-in'); }, 200);
    });
  }

  /* -------- REVEAL ON SCROLL -------- */
  function setupReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(e) { e.classList.add('is-in'); });
      return;
    }
    // Immediate pass: elements already in viewport reveal now.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function(e) {
      var r = e.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        e.classList.add('is-in');
      }
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(e) {
      if (!e.classList.contains('is-in')) io.observe(e);
    });
  }

  /* -------- STATS COUNTER -------- */
  function setStatic(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var suffix = el.getAttribute('data-suffix') || '';
    el.textContent = target + suffix;
  }
  function setupCounters() {
    var nums = document.querySelectorAll('[data-count]');
    nums.forEach(setStatic);
  }

  /* -------- FAQ — sync details open state with class -------- */
  function setupFAQ() {
    var items = document.querySelectorAll('.cleo-faq__item');
    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (item.open) item.classList.add('is-open');
        else item.classList.remove('is-open');
      });
    });
  }

  /* -------- FORM submit -------- */
  function setupForm() {
    var form = document.getElementById('cleo-form-preregistro');
    var success = document.getElementById('cleo-form-success');
    var btn = document.getElementById('bl-pg-btn');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      // honeypot check
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) return; // bot

      // ciudad: validar que se haya elegido del dropdown custom
      var cityVal = document.getElementById('bl-pg-city-val');
      var cityInput = document.getElementById('bl-pg-city-input');
      if (cityVal && !cityVal.value) {
        if (cityInput) {
          cityInput.style.borderColor = '#e0457a';
          cityInput.focus();
        }
        alert('Por favor elegí tu ciudad de la lista.');
        return;
      }

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Enviando…';

      var data = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: data,
        mode: 'no-cors'
      }).then(function() {
        form.style.display = 'none';
        success.classList.add('is-active');
        success.scrollIntoView ? null : null; // intentionally not scrolling
      }).catch(function() {
        form.style.display = 'none';
        success.classList.add('is-active');
      }).finally(function() {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    });

    // WhatsApp input — light formatting
    var wa = document.getElementById('bl-pg-wa');
    if (wa) {
      wa.addEventListener('input', function() {
        var v = wa.value.replace(/[^\d]/g, '').slice(0, 10);
        if (v.length > 4) v = v.slice(0, 4) + ' ' + v.slice(4);
        if (v.length > 8) v = v.slice(0, 8) + ' ' + v.slice(8);
        wa.value = v;
      });
    }
  }

  /* -------- CIUDAD — dropdown custom buscador -------- */
  function setupCityDropdown() {
    var wrap = document.getElementById('cleo-city-wrap');
    var input = document.getElementById('bl-pg-city-input');
    var arrow = wrap ? wrap.querySelector('.cleo-city-arrow') : null;
    var dd = document.getElementById('cleo-city-dd');
    var search = document.getElementById('cleo-city-search');
    var list = document.getElementById('cleo-city-list');
    var hidden = document.getElementById('bl-pg-city-val');
    if (!wrap || !input || !dd || !list || !hidden) return;

    function openDD() {
      dd.classList.add('is-open');
      wrap.classList.add('is-open');
      search.value = '';
      filterList('');
      setTimeout(function() { search.focus(); }, 40);
    }
    function closeDD() {
      dd.classList.remove('is-open');
      wrap.classList.remove('is-open');
    }
    function filterList(q) {
      var qq = q.toLowerCase().trim();
      var anyVisible = false;
      list.querySelectorAll('li:not(.is-empty)').forEach(function(li) {
        var match = li.textContent.toLowerCase().indexOf(qq) >= 0;
        li.hidden = !match;
        if (match) anyVisible = true;
      });
      var empty = list.querySelector('.is-empty');
      if (!anyVisible) {
        if (!empty) {
          empty = document.createElement('li');
          empty.className = 'is-empty';
          empty.textContent = 'Sin resultados — escribí tu ciudad';
          list.appendChild(empty);
        }
        empty.hidden = false;
      } else if (empty) {
        empty.hidden = true;
      }
    }
    input.addEventListener('click', function() {
      dd.classList.contains('is-open') ? closeDD() : openDD();
    });
    if (arrow) arrow.addEventListener('click', function() {
      dd.classList.contains('is-open') ? closeDD() : openDD();
    });
    search.addEventListener('input', function() { filterList(this.value); });
    list.addEventListener('click', function(e) {
      var li = e.target.closest('li');
      if (!li || li.classList.contains('is-empty')) return;
      input.value = li.dataset.val;
      hidden.value = li.dataset.val;
      input.style.color = 'var(--cleo-negro)';
      closeDD();
    });
    document.addEventListener('click', function(e) {
      if (!wrap.contains(e.target)) closeDD();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && dd.classList.contains('is-open')) closeDD();
    });
  }

  /* -------- INIT -------- */
  function init() {
    document.body.classList.add('js-anim');
    buildHeroTitle();
    setupReveals();
    setupCounters();
    setupFAQ();
    setupCityDropdown();
    setupForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
